import React, { useEffect, useState } from "react";
import { Button, Checkbox, CircularProgress, FormControlLabel, InputAdornment, TextField, Typography } from "@mui/material";



export default function WBButton ({ handleClick, icon, labelText, loading,  ...rest }) {

    return(
        <Button 
            onClick={handleClick ? handleClick : () => {return}} 
            disabled={loading}
            {...rest}
        >
            {labelText}
            {
                (!loading && icon) && icon
            }
            {
                loading && <CircularProgress sx={{width: "20px !important", height: "20px !important", mr: 2, color: "rgba(0, 0, 0, 0.26)"}} />
            }
        </Button>
    )
}